import {
  PaccProfileFactorDto,
  PaccProfileResultRs,
  PaccProfileSubFactorDto,
  PaccProfileSubFactorQuestionDto,
} from '@domain/rs/phs/pacc/competence/PaccProfileResultRs';
import { FactorType } from '@domain/constant/factorType';
import { SubFactorType } from '@domain/constant/subFactorType';
import { AccaProfileType } from '@domain/constant/AccaProfileType';

export class PaccProfileSubFactorQuestionVO {
  question: string;
  comment: string;
  priority: number;

  constructor(dto: PaccProfileSubFactorQuestionDto) {
    this.question = dto.question;
    this.comment = dto.comment;
    this.priority = dto.priority;
  }
}

export class PaccProfileSubFactorVO {
  type: SubFactorType;
  keyword: string;
  comment: string;
  priority: number;
  questions: PaccProfileSubFactorQuestionVO[];

  constructor(dto: PaccProfileSubFactorDto) {
    this.type = dto.type;
    this.keyword = dto.keyword;
    this.comment = dto.comment;
    this.priority = dto.priority;
    this.questions = dto.questions?.map((dto) => new PaccProfileSubFactorQuestionVO(dto));
  }
}

export class PaccProfileFactorVO {
  type: FactorType;
  score: number;

  constructor(dto: PaccProfileFactorDto) {
    this.type = dto.type;
    this.score = dto.score;
  }
}

export class PaccProfileResultVO {
  sn: number;
  type: AccaProfileType;
  factors: PaccProfileFactorVO[];
  topFactorTypes: FactorType[];
  strengths: PaccProfileSubFactorVO[];
  weaknesses: PaccProfileSubFactorVO[];

  constructor(rs: PaccProfileResultRs) {
    this.sn = rs.sn;
    this.type = rs.type;
    this.factors = rs.factors?.map((dto) => new PaccProfileFactorVO(dto));
    this.topFactorTypes = rs.topFactorTypes;
    this.strengths = rs.strengths?.map((dto) => new PaccProfileSubFactorVO(dto));
    this.weaknesses = rs.weaknesses?.map((dto) => new PaccProfileSubFactorVO(dto));
  }
}
